import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Avatar, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { find, map } from 'lodash';

import httpService from 'src/_services/httpService';
import { languages } from '.';

const LanguageToggleButton = styled(ToggleButton)(({ theme }) => ({
  height: '44px',
  gap: '8px',
  borderRadius: '6px',
  textTransform: 'none',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '20px',
  padding: '10px 14px',
  width: '111px'
}));

export default function LocalizationToggle({ onClick, reload = false }) {

  const { i18n } = useTranslation('public');
  const [currentLanguage, setCurrentLanguage] = React.useState(i18n.language);

  const languageToToggle = React.useMemo(() => {
    return find(languages, lang => lang.id != currentLanguage)
  }, [currentLanguage])

  const handleLanguageClick = (event, language) => {
    if (!!onClick) { onClick() }
    if (language != languageToToggle?.id) return;
    i18n.changeLanguage(languageToToggle?.id);
    setCurrentLanguage(languageToToggle?.id);
    httpService.setHttpMessagesLanguage(languageToToggle?.id);
    if (reload) {
      window.location.reload()
    }
  };

  return (
    <ToggleButtonGroup
      value={currentLanguage}
      exclusive
      onChange={handleLanguageClick}
      sx={{
        m: 2, padding: '6px', gap: '8px',
        borderRadius: '8px', border: '#F2F4F7', borderColor: '#F2F4F7', borderWidth: 1, borderStyle: 'solid',
        background: '#F9FAFB',
      }}
    >
      {
        map(
          languages,
          ({ id, title, imageSource }) => (
            <LanguageToggleButton
              sx={{
                color: currentLanguage === id ? "#344054" : "#667085",
                backgroundColor: currentLanguage === id ? "white !important" : "transparent",
                borderWidth: `${currentLanguage === id ? '1' : '0'}px !important`,
                ':hover': { backgroundColor: `${currentLanguage === id ? "white" : "transparent"} !important` },
                boxShadow: currentLanguage === id ? '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)' : undefined
              }}
              key={id}
              disableRipple
              value={id}
              aria-label={title}
            >
              <Avatar sx={{ width: '20px', height: '20px' }} src={imageSource} />
              {title}
            </LanguageToggleButton>
          ))}
    </ToggleButtonGroup>
  );
}